import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from '@app/_core/services/user.service';
import { LoaderService } from '@app/_core/services/loader.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  // Injector is used instead of constructor DI to avoid circular-dependency
  // issues, since ErrorHandler is instantiated very early in the bootstrap process.
  constructor(private injector: Injector) { }
  private readonly CALL_ERROR_LOG_API = false;
  handleError(error: unknown): void {
    const ngZone = this.injector.get(NgZone);
    const loaderService = this.injector.get(LoaderService);
    const userService = this.injector.get(UserService);

    // HttpErrorResponses are already handled by the HTTP interceptor —
    // avoid double-logging the same error through this global handler.
    if (error instanceof HttpErrorResponse) {
      return;
    }

    const err = error as Error;
    const errorMessage = err?.message || 'An unexpected error occurred.';
    const stack = err?.stack || 'No stack trace available.';

    console.error('[Unhandled Runtime Error]: ', errorMessage);
    //console.error('Stack Trace:', stack);

    // Run inside NgZone so UI updates (loader, toasts) trigger change detection.
    // handleError itself can execute outside the Angular zone in some edge cases.
    ngZone.run(() => {
      loaderService.display(false);
      loaderService.setOnDemandLoading(false);
      if (userService.isLoggedIn() && this.CALL_ERROR_LOG_API) {
        const errorPayload = {
          message: `${errorMessage} | ${stack}`,
          apiInfo: {
            url: window.location.href, // no HTTP request context available here
            params: '',
          },
          source: 'GlobalErrorHandler',
        };

        userService.APIErrorLog(errorPayload).subscribe({
          next: (res) => console.log('Runtime error logged to backend:', res),
          error: (logError) =>
            console.error('Failed to log runtime error to backend:', logError),
        });
      }
    });

    // Optionally rethrow in dev mode so it still shows in browser console
    // with full Angular stack trace / source maps intact.
    //throw error;
  }
}